const escapeHtml = (value) =>
    String(value).replace(
        /[&<>"']/g,
        (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]
    )

const populateFilterOptions = (select, items, key) => {
    const values = [...new Set(items.map((item) => item[key]).filter(Boolean))].sort()
    values.forEach((value) => {
        const option = document.createElement('option')
        option.value = value
        option.textContent = value
        select.appendChild(option)
    })
}

const initCareersBlock = (block) => {
    const locationSelect = block.querySelector('.js-careers-location')
    const departmentSelect = block.querySelector('.js-careers-department')
    const viewAllButton = block.querySelector('.js-careers-view-all')
    const clearButton = block.querySelector('.js-careers-clear')
    const countEl = block.querySelector('.js-careers-count')
    const listEl = block.querySelector('.js-careers-list')

    let vacancies = []

    const reset = () => {
        locationSelect.value = 'all'
        departmentSelect.value = 'all'
        countEl.hidden = true
        countEl.textContent = ''
        listEl.hidden = true
        listEl.innerHTML = ''
        clearButton.hidden = true
    }

    const render = () => {
        countEl.hidden = false
        listEl.hidden = false
        clearButton.hidden = false

        const location = locationSelect.value
        const department = departmentSelect.value

        const filtered = vacancies
            .filter((item) => location === 'all' || item.City === location)
            .filter((item) => department === 'all' || item.Department === department)
            .sort((a, b) => (a.VacancyName || '').localeCompare(b.VacancyName || ''))

        countEl.textContent = `${filtered.length} ${filtered.length === 1 ? 'job' : 'jobs'} found`

        listEl.innerHTML = filtered
            .map(
                (item) => `
                    <li class="flex flex-col xs:flex-row items-start xs:items-center justify-between gap-4 p-6 bg-white rounded border border-black-200">
                        <span class="flex flex-col gap-1">
                            <span class="h3">${escapeHtml(item.VacancyName || '')}</span>
                            <span class="flex items-center gap-1 font-weight-bold text-black-500">
                                <svg viewBox="0 0 20 24" aria-hidden="true" class="w-3 h-3.5 shrink-0"><use href="#icon-map-pin"></use></svg>
                                <span class="text-tiny">${escapeHtml(item.City || '')}</span>
                            </span>
                        </span>
                        <a href="${escapeHtml(item.JobBordUrl || '#')}" target="_blank" rel="noopener noreferrer" class="btn max-xs:ml-auto" data-type="primary" data-tone="brand" data-size="small">
                            <span class="text-tiny">View details<span class="sr-only"> (opens in a new tab)</span></span>
                            <svg viewBox="0 0 20 20" aria-hidden="true"><use href="#icon-external-link"></use></svg>
                        </a>
                    </li>
                `,
            )
            .join('')
    }

    fetch('/careers-vacancies.json')
        .then((response) => response.json())
        .then((data) => {
            vacancies = Array.isArray(data) ? data : []
            populateFilterOptions(locationSelect, vacancies, 'City')
            populateFilterOptions(departmentSelect, vacancies, 'Department')
            locationSelect.disabled = false
            departmentSelect.disabled = false
            viewAllButton.disabled = false
        })
        .catch(() => {
            countEl.hidden = false
            countEl.textContent = 'Unable to load current vacancies.'
        })

    locationSelect.addEventListener('change', render)
    departmentSelect.addEventListener('change', render)
    viewAllButton.addEventListener('click', () => {
        locationSelect.value = 'all'
        departmentSelect.value = 'all'
        render()
    })
    clearButton.addEventListener('click', reset)
}

const careersBlockInit = () => {
    const blocks = [...document.querySelectorAll('.js-careers-widget')]
    blocks.forEach(initCareersBlock)
}
careersBlockInit()
